import React from 'react';
import { Panel, Col, Table } from 'react-bootstrap';
import {
  combinedCourseOptions,
  unitTypes
} from "../config/constants";

const CollegeSummary = (props) => {
  const renderCourseRows = () => {
    return props.courses.map((course) => {
      return (
        <tr key={course.id}>
          <td>{course.name}</td>
          <td>{course.grade}</td>
          <td>{course.units}</td>
          <td>{course.term} {course.year}</td>
          <td>{combinedCourseOptions[course.requirement]}</td>
          <td>{course.repeat ? 'Yes' : 'No'}</td>
        </tr>
      );
    });
  };

  const renderCourseTable = () => {
    if(props.courses.length === 0) {
      return <div className="college-courses">No courses for college</div>;
    }
    return (
      <div className="college-courses">
        <h4 className="summary-sub-category">Courses</h4>
        <Table striped>
          <thead>
          <tr>
            <th>
              Name
            </th>
            <th>
              Grade
            </th>
            <th>
              Units
            </th>
            <th>
              Term
            </th>
            <th>
              Requirement
            </th>
            <th>
              Repeat
            </th>
          </tr>
          </thead>
          <tbody>
          {renderCourseRows()}
          </tbody>
        </Table>
      </div>
    )
  };

  return(
    <Panel className="college-panel nested-panel">
      <Panel className="nested-panel">
        <Col sm={6}>
          <span className="summary-label">College Name</span>
          <span className="summary-data">{props.name}</span>
        </Col>
        <Col sm={4}>
          <span className="summary-label">Location</span>
          <span className="summary-data">{props.location}</span>
        </Col>
        <Col sm={2}>
          <span className="summary-label">Unit Type</span>
          <span className="summary-data">{unitTypes[props.unitType]}</span>
        </Col>
      </Panel>
      {renderCourseTable()}
    </Panel>
  );
};

export default CollegeSummary;